import type { RabbitHoleDiscovery, RabbitHoleWeek } from "../hooks/useRabbitHole";
import type { GeneratedText } from "../hooks/types/GeneratedTexts";

export function resolveCanonicalGeneratedTextForRabbitHoleDiscovery(arg: {
  discovery: RabbitHoleDiscovery | null | undefined;
  generatedTexts: GeneratedText[];
}): GeneratedText | undefined {
  if (!arg.discovery) {
    return undefined;
  }

  return arg.generatedTexts.find((text) => text.id === arg.discovery?.id);
}

export function resolveEffectiveRabbitHoleDiscovery(arg: {
  discovery: RabbitHoleDiscovery | null | undefined;
  generatedTexts: GeneratedText[];
}): RabbitHoleDiscovery | GeneratedText | undefined {
  return (
    resolveCanonicalGeneratedTextForRabbitHoleDiscovery(arg) ?? arg.discovery ?? undefined
  );
}

export function isRabbitHoleDiscoveryRead(
  discovery:
    | Pick<RabbitHoleDiscovery, "view_count" | "learning_progress">
    | Pick<GeneratedText, "view_count" | "learning_progress">
    | null
    | undefined,
): boolean {
  return Boolean(discovery && discovery.view_count > 0);
}

export function isRabbitHoleWeekActive(
  week: RabbitHoleWeek | undefined,
): week is RabbitHoleWeek {
  return Boolean(week && (week.status === "PLANNING" || week.status === "ACTIVE"));
}

export function findRabbitHoleDiscoveryForDate(
  week: RabbitHoleWeek | undefined,
  dateIso: string,
): RabbitHoleDiscovery | undefined {
  if (!week?.discoveries?.length || !week.week_start) return undefined;
  const weekStart = new Date(`${week.week_start}T00:00:00`);
  const targetDate = new Date(`${dateIso}T00:00:00`);
  const dayOffset = Math.round(
    (targetDate.getTime() - weekStart.getTime()) / (1000 * 60 * 60 * 24),
  );
  return week.discoveries.find((discovery) =>
    discovery.rabbit_hole_day_index === dayOffset,
  );
}
